import { canCreateOrUpdate } from './validators/functions/can-create-or-update.function';
import { canPerformAction } from './validators/functions/can-perform-action.function';

export * from './dtos/create-vehicle-insurance.dto';
export * from './dtos/update-vehicle-insurance.dto';
export * from './dtos/vehicle-insurance-list.dto';
export * from './dtos/vehicle-insurance-record.dto';
export * from './dtos/vehicle-insurance-activity-event.dto';
export * from './dtos/vehicle-insurance-activity-event-hydration.dto';
export * from './dtos/vehicle-insurance-search.dto';
export * from './dtos/vehicle-insurances-stats.dto';

export * from './enums/vehicle-insurance-record-category.enum';
export * from './enums/vehicle-insurance-coverage-type.enum';
export * from './enums/vehicle-insurance-status.enum';
export * from './enums/vehicle-insurance-action.enum';
export * from './enums/vehicle-insurance-premium-period.enum';

export * from './functions/vehicle-insurance-status-to-color.function';

export * from './types/vehicle-insurances-filters';
export * from './validators/schemas/create-vehicle-insurance.schema';
export * from './validators/schemas/update-vehicle-insurance.schema';

export const vehicleInsuranceValidators = {
  canCreateOrUpdate,
  canPerformAction,
};
